import { render, staticRenderFns } from "./header-block.vue?vue&type=template&id=233f7adc&scoped=true"
import script from "./header-block.vue?vue&type=script&lang=js"
export * from "./header-block.vue?vue&type=script&lang=js"
import style0 from "./header-block.vue?vue&type=style&index=0&id=233f7adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233f7adc",
  null
  
)

export default component.exports